import { Badge, Table, TableBody, TableCell, TableHead, TableHeaderCell, TableRow, Text } from '@tremor/react';
import type { DviInspection } from '../../api/types';
import { t } from '../../lib/i18n';

const fmtMxn = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0 });

/**
 * Recent-inspections table: WO#, vehicle, 🟢🟡🔴 status-summary badges, and
 * recommended total. Extracted out of the Service cockpit's Dvi tab
 * (pages/service/Dvi.tsx) so the standalone staff-reachable Inspecciones
 * page (pages/dvi/Inspecciones.tsx) can render the exact same list — both
 * fetch the same `fetchDviRecent()` shape and share this rendering rather
 * than duplicating it.
 *
 * `rows === null` is the loading state (fetch in flight); `[]` is the
 * confirmed-empty state — callers pass whichever they currently have.
 */
export default function DviRecentList({ rows }: { rows: DviInspection[] | null }) {
  const c = t.dvi;

  if (rows === null) return <Text>…</Text>;
  if (rows.length === 0) return <Text>{c.empty}</Text>;

  return (
    <Table>
      <TableHead><TableRow>
        <TableHeaderCell>OT</TableHeaderCell>
        <TableHeaderCell>Vehículo</TableHeaderCell>
        <TableHeaderCell>Estado</TableHeaderCell>
        <TableHeaderCell className="text-right">{c.recommendedTotal}</TableHeaderCell>
      </TableRow></TableHead>
      <TableBody>
        {rows.map((r) => (
          <TableRow key={r.id}>
            <TableCell>#{r.tnum}</TableCell>
            <TableCell>{r.vehicle_desc || r.customer_name}</TableCell>
            <TableCell>
              <span className="inline-flex gap-1">
                <Badge color="green">{r.summary.green}</Badge>
                <Badge color="yellow">{r.summary.yellow}</Badge>
                <Badge color="red">{r.summary.red}</Badge>
              </span>
            </TableCell>
            <TableCell className="text-right tabular-nums">{fmtMxn.format(r.recommended_total)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
